import { render, staticRenderFns } from "./regiao-edit-item.vue?vue&type=template&id=34cd3b08&"
import script from "./regiao-edit-item.vue?vue&type=script&lang=js&"
export * from "./regiao-edit-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports